import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { mediaMax, calculateResponsiveSize } from 'styles/media-queries'

export const List = styled.ul`
  display: flex;
  align-items: center;
  z-index: 1;

  gap: ${calculateResponsiveSize(29.5)};
  ${mediaMax('mobile')} {
    display: none;
  }
`
export const Li = styled.li`
  display: flex;
  align-items: center;
  gap: ${calculateResponsiveSize(12)};
  position: relative;
`

export const Item = styled((props) => <Link {...props} />)`
  color: var(--blue);
  &:hover,
  &:active,
  &:visited {
    color: var(--blue);
    text-decoration: none;
  }
  display: flex;
  padding-top: ${calculateResponsiveSize(4)};

  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  transition: 0.5s;
  text-transform: uppercase;

  font-family: 'Basis Grotesque Pro';
  font-size: ${calculateResponsiveSize(10)};
  font-weight: 400;
  line-height: ${calculateResponsiveSize(16)};
  letter-spacing: ${calculateResponsiveSize(2)};

  li.active & {
    font-weight: 700;
  }
  &:hover {
  }

  ${mediaMax('mobile')} {
  }
`
export const MainLink = styled((props) => <Link {...props} />)`
  font-family: 'Canela';
  font-size: ${calculateResponsiveSize(18)};
  font-weight: 300;
  line-height: ${calculateResponsiveSize(28.8)};
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  padding-bottom: ${calculateResponsiveSize(5)};
  display: flex;
  flex-direction: column;
  height: ${calculateResponsiveSize(33)};
  & span {
    transform: translateY(0);
    transition: 0.5s;
  }
  &:hover {
    & span {
      transform: translateY(-${calculateResponsiveSize(28)});
    }
  }
  overflow: hidden;
`
